export default __webpack_public_path__ + "static/media/wi-day-sunny-overcast.db7b549b.svg";